// 배차 관리 (admin) — 낙찰·입금완료 차량을 캐리어에 배차 + 배차표 엑셀 (배차 D2, 2026-06-02)
//   백엔드: routes/dispatch.js (eligible-cars/create/list/detail/items pickup/status/delete/xlsx)
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var NAVY = '#1B3A5C';
var ST_COLOR = { '작성': '#94a3b8', '전달': '#2563eb', '운송중': '#ea580c', '완료': '#16a34a' };

function DispatchAdmin({ showToast }) {
  var st = showToast || function () {};
  var listState = useState([]); var list = listState[0]; var setList = listState[1];
  var carriersState = useState([]); var carriers = carriersState[0]; var setCarriers = carriersState[1];
  var yardsState = useState([]); var yards = yardsState[0]; var setYards = yardsState[1];
  var newState = useState(false); var showNew = newState[0]; var setShowNew = newState[1];
  var eligibleState = useState([]); var eligible = eligibleState[0]; var setEligible = eligibleState[1];
  var formState = useState({ carrierId: '', shoringYardId: '', pickupDate: '', memo: '', carIds: [] });
  var form = formState[0]; var setForm = formState[1];
  var detailState = useState(null); var detail = detailState[0]; var setDetail = detailState[1];

  function loadList() { authFetch(API + '/dispatch').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setList(d.items || []); }).catch(function () {}); }
  function loadCarriers() { authFetch(API + '/carriers').then(function (r) { return r.json(); }).then(function (d) { if (Array.isArray(d)) setCarriers(d.filter(function (c) { return c.active; })); }).catch(function () {}); }
  function loadYards() { authFetch(API + '/shoring-yards').then(function (r) { return r.json(); }).then(function (d) { if (Array.isArray(d)) setYards(d.filter(function (y) { return y.active; })); }).catch(function () {}); }
  useEffect(function () { loadList(); loadCarriers(); loadYards(); }, []);

  function openNew() {
    setForm({ carrierId: '', shoringYardId: '', pickupDate: '', memo: '', carIds: [] });
    authFetch(API + '/dispatch/eligible-cars').then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setEligible(d.cars || []); }).catch(function () {});
    setShowNew(true);
  }
  function toggleCar(id) {
    setForm(function (f) { var has = f.carIds.indexOf(id) >= 0; return Object.assign({}, f, { carIds: has ? f.carIds.filter(function (x) { return x !== id; }) : f.carIds.concat([id]) }); });
  }
  function createDispatch() {
    if (!form.carrierId) { st('캐리어를 선택하세요', 'err'); return; }
    if (form.carIds.length === 0) { st('차량을 선택하세요', 'err'); return; }
    authFetch(API + '/dispatch', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.success) { st('배차 생성됨 ' + (d.dispatchNo || ''), ''); setShowNew(false); loadList(); } else st((d && d.error) || '생성 실패', 'err'); })
      .catch(function () { st('생성 실패', 'err'); });
  }
  function openDetail(id) { authFetch(API + '/dispatch/' + id).then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) setDetail(d.dispatch); }).catch(function () {}); }
  function savePickup(itemId, addr) {
    authFetch(API + '/dispatch/items/' + itemId, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pickupAddress: addr }) })
      .then(function (r) { return r.json(); }).then(function (d) { if (!(d && d.success)) st('픽업주소 저장 실패', 'err'); }).catch(function () {});
  }
  function setStatus(id, status) {
    authFetch(API + '/dispatch/' + id + '/status', { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status: status }) })
      .then(function (r) { return r.json(); }).then(function (d) { if (d && d.success) { st('상태 변경됨', ''); loadList(); if (detail && detail.id === id) openDetail(id); } else st((d && d.error) || '실패', 'err'); }).catch(function () {});
  }
  function remove(d) {
    if (!window.confirm('배차 ' + d.dispatch_no + '를 삭제할까요? (작성 상태만 가능)')) return;
    authFetch(API + '/dispatch/' + d.id, { method: 'DELETE' }).then(function (r) { return r.json(); })
      .then(function (x) { if (x && x.success) { st('삭제됨', ''); loadList(); } else st((x && x.error) || '삭제 실패', 'err'); }).catch(function () {});
  }
  function downloadXlsx(d) {
    authFetch(API + '/dispatch/' + d.id + '/xlsx').then(function (r) { if (!r.ok) throw new Error('x'); return r.blob(); })
      .then(function (blob) { var url = URL.createObjectURL(blob); var a = document.createElement('a'); a.href = url; a.download = '배차표_' + (d.dispatch_no || '') + '.xlsx'; document.body.appendChild(a); a.click(); a.remove(); setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 1000); })
      .catch(function () { st('엑셀 생성 실패', 'err'); });
  }

  return (
    <div style={{ padding: '20px 24px', maxWidth: 1100, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>{'🚚 배차 관리'}</div>
          <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{'낙찰·입금완료 차량을 캐리어에 배차 → 쇼링장 운송'}</div>
        </div>
        <button onClick={openNew} style={{ padding: '9px 20px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>{'+ 새 배차'}</button>
      </div>

      <div style={{ overflowX: 'auto', border: '1px solid #e5e7eb', borderRadius: 10 }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff' }}>
          <thead><tr style={{ background: '#f8fafc' }}>
            <th style={thS}>{'배차번호'}</th><th style={thS}>{'캐리어'}</th><th style={thS}>{'쇼링장'}</th><th style={thS}>{'픽업일'}</th>
            <th style={thC}>{'차량'}</th><th style={thC}>{'상태'}</th><th style={thC}>{'관리'}</th>
          </tr></thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={7} style={{ padding: 30, textAlign: 'center', color: '#94a3b8' }}>{'배차 내역이 없습니다'}</td></tr>}
            {list.map(function (d) {
              return (
                <tr key={d.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                  <td style={Object.assign({ fontWeight: 700, color: NAVY }, tdS)}>{d.dispatch_no}</td>
                  <td style={tdS}>{d.carrierName}</td>
                  <td style={tdS}>{d.shoring_yard || '-'}</td>
                  <td style={tdS}>{d.pickup_date || '-'}</td>
                  <td style={tdC}>{d.carCount}</td>
                  <td style={tdC}><span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: ST_COLOR[d.status] || '#94a3b8', borderRadius: 10, padding: '2px 8px' }}>{d.status}</span></td>
                  <td style={tdC}>
                    <button onClick={function () { openDetail(d.id); }} style={btnGray}>{'상세'}</button>
                    <button onClick={function () { downloadXlsx(d); }} style={Object.assign({}, btnGray, { color: '#15803d', borderColor: '#bbf7d0', background: '#f0fdf4' })}>{'📋 엑셀'}</button>
                    {d.status === '작성' && <button onClick={function () { remove(d); }} style={Object.assign({}, btnGray, { color: '#dc2626', borderColor: '#fecaca', background: '#fef2f2' })}>{'삭제'}</button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* 새 배차 모달 */}
      {showNew && (
        <div style={modalBg} onClick={function () { setShowNew(false); }}>
          <div style={Object.assign({}, modalBox, { width: 560 })} onClick={function (e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: NAVY, marginBottom: 12 }}>{'새 배차'}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
              <select value={form.carrierId} onChange={function (e) { setForm(Object.assign({}, form, { carrierId: e.target.value })); }} style={inp}>
                <option value="">{'캐리어 선택 *'}</option>
                {carriers.map(function (c) { return <option key={c.id} value={c.id}>{c.name}</option>; })}
              </select>
              <select value={form.shoringYardId} onChange={function (e) { setForm(Object.assign({}, form, { shoringYardId: e.target.value })); }} style={inp}>
                <option value="">{'쇼링장 선택 (선택)'}</option>
                {yards.map(function (y) { return <option key={y.id} value={y.id}>{y.name}</option>; })}
              </select>
              <input type="date" value={form.pickupDate} onChange={function (e) { setForm(Object.assign({}, form, { pickupDate: e.target.value })); }} style={inp} />
              <input value={form.memo} onChange={function (e) { setForm(Object.assign({}, form, { memo: e.target.value })); }} placeholder="메모" style={inp} />
            </div>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', margin: '8px 0 6px' }}>{'배차 차량 선택 (' + form.carIds.length + '대) — 낙찰·입금완료 미배차'}</div>
            <div style={{ maxHeight: 240, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
              {eligible.length === 0 && <div style={{ padding: 20, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>{'배차 가능 차량이 없습니다'}</div>}
              {eligible.map(function (c) {
                var checked = form.carIds.indexOf(c.id) >= 0;
                return (
                  <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer', background: checked ? '#eff6ff' : '#fff' }}>
                    <input type="checkbox" checked={checked} onChange={function () { toggleCar(c.id); }} />
                    <span style={{ fontWeight: 600, color: NAVY }}>{c.carNo}</span>
                    <span style={{ fontSize: 12, color: '#64748b' }}>{c.carType}</span>
                    <span style={{ fontSize: 11, color: '#94a3b8' }}>{(c.buyerName || '') + (c.buyAddress ? ' · ' + c.buyAddress : '')}</span>
                  </label>
                );
              })}
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
              <button onClick={function () { setShowNew(false); }} style={{ flex: 1, padding: '10px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'취소'}</button>
              <button onClick={createDispatch} style={{ flex: 2, padding: '10px', background: NAVY, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>{'배차 생성'}</button>
            </div>
          </div>
        </div>
      )}

      {/* 상세 모달 */}
      {detail && (
        <div style={modalBg} onClick={function () { setDetail(null); }}>
          <div style={Object.assign({}, modalBox, { width: 600, maxHeight: '85vh', display: 'flex', flexDirection: 'column' })} onClick={function (e) { e.stopPropagation(); }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: NAVY }}>{'배차 ' + detail.dispatch_no}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 10 }}>{'캐리어: ' + (detail.carrierName || '') + (detail.carrierTel ? ' (' + detail.carrierTel + ')' : '') + ' · 쇼링장: ' + (detail.shoring_yard || '-') + ' · 픽업: ' + (detail.pickup_date || '-')}</div>
            <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
              {['작성', '전달', '운송중', '완료'].map(function (s) {
                return <button key={s} onClick={function () { setStatus(detail.id, s); }} style={{ padding: '4px 12px', borderRadius: 8, border: '1px solid ' + (detail.status === s ? NAVY : '#e5e7eb'), background: detail.status === s ? NAVY : '#fff', color: detail.status === s ? '#fff' : '#64748b', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{s}</button>;
              })}
              <button onClick={function () { downloadXlsx(detail); }} style={{ padding: '4px 12px', borderRadius: 8, border: '1px solid #bbf7d0', background: '#f0fdf4', color: '#15803d', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>{'📋 배차표 엑셀'}</button>
            </div>
            <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead><tr style={{ background: '#f8fafc' }}><th style={thS}>{'#'}</th><th style={thS}>{'차량'}</th><th style={thS}>{'차종'}</th><th style={thS}>{'픽업 주소'}</th></tr></thead>
                <tbody>
                  {(detail.items || []).map(function (it) {
                    return (
                      <tr key={it.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                        <td style={tdS}>{it.seq}</td>
                        <td style={Object.assign({ fontWeight: 600 }, tdS)}>{it.carNo}</td>
                        <td style={tdS}>{it.carType}</td>
                        <td style={tdS}><input defaultValue={it.pickup_address} onBlur={function (e) { if (e.target.value !== it.pickup_address) savePickup(it.id, e.target.value); }} style={{ width: '100%', padding: '4px 6px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 12, boxSizing: 'border-box' }} /></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <button onClick={function () { setDetail(null); }} style={{ marginTop: 10, padding: '8px', background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>{'닫기'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

var thS = { padding: '9px 10px', textAlign: 'left', fontWeight: 700, fontSize: 12, color: '#475569' };
var thC = Object.assign({}, thS, { textAlign: 'center' });
var tdS = { padding: '8px 10px', color: '#334155' };
var tdC = Object.assign({}, tdS, { textAlign: 'center' });
var btnGray = { marginRight: 4, padding: '3px 10px', border: '1px solid #cbd5e1', background: '#f8fafc', color: '#475569', borderRadius: 6, fontSize: 11, fontWeight: 600, cursor: 'pointer' };
var inp = { padding: '8px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13, boxSizing: 'border-box' };
var modalBg = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 };
var modalBox = { background: '#fff', borderRadius: 14, padding: 20, maxWidth: '94vw' };

export default DispatchAdmin;
